import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Grid, Link, Typography, units } from '@hbf/dsl';

import { ContentfulImg } from 'ha/modules/Contentful/components/ContentfulImg';
import { useSelector } from 'react-redux';
import { getCurrentLanguageCode } from 'ha/modules/LanguageSwitcher/selectors';
import { ImagePosition } from '@ha/contentful';
import { ValuePropositionData } from './types';

const useStyles = makeStyles()(theme => ({
  img: {
    maxHeight: units.rem(25),
  },
  container: {
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
    },
  },
  title: {
    marginBottom: units.rem(1),
    [theme.breakpoints.up('md')]: {
      marginBottom: units.rem(1.25),
    },
  },
  text: {
    [theme.breakpoints.down('md')]: {
      marginBottom: units.rem(1.5),
    },
  },
  link: {
    marginTop: units.rem(1.5),
  },
}));

export interface Props {
  valueProposition: ValuePropositionData;
}

export const VpDefault: React.FC<Props> = ({
  valueProposition: {
    title,
    description,
    image: img,
    imageAsset,
    linkTitle,
    linkUrl,
    imagePosition = ImagePosition.RIGHT,
  },
}) => {
  const { classes } = useStyles();
  const image = imageAsset || { fields: { url: img } };
  const lang = useSelector(getCurrentLanguageCode);
  const desc = image.fields.description;
  const alt = desc ? desc[lang] || desc.en : '';
  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      className={classes.container}
      direction={imagePosition === ImagePosition.LEFT ? 'row-reverse' : 'row'}
    >
      <Grid item xs={12} md={6} className={classes.text}>
        <Typography.H1 className={classes.title} component="h3">
          {title}
        </Typography.H1>
        <Typography.Paragraph>{description}</Typography.Paragraph>
        {linkTitle && linkUrl && (
          <div className={classes.link}>
            <Link kind="mint-uppercase" to={linkUrl}>
              {linkTitle}
            </Link>
          </div>
        )}
      </Grid>
      <Grid
        item
        container
        alignItems="center"
        justifyContent="center"
        xs={12}
        md={5}
      >
        <div>
          <ContentfulImg
            src={image.fields.url}
            defaultSrc={image.fields.url}
            alt={alt}
            className={classes.img}
            role="presentation"
            sizes={{ xs: '400px' }}
            isResponsive
          />
        </div>
      </Grid>
    </Grid>
  );
};
